import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import endUserDevicesHero from "../assets/Hero/end-user-hero.jpg"; // Replace with your hero image
import endUserDevicesImage from "../assets/Hero/end-user.jpg"; // Replace with your end user devices image
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/endUserDevicesPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const endUserDevicesData = {
  hero: {
    title: "End User Devices",
    subtitle: "Empowering Your Workforce with Cutting-Edge Devices",
  },
  introduction: {
    heading: "Why End User Devices Matter",
    paragraphs: [
      "End user devices are essential tools for modern businesses, enabling productivity, collaboration, and efficiency.",
      "Our end user device solutions are designed to provide high performance, reliability, and seamless integration with your business workflows.",
    ],
  },
  features: {
    heading: "Our End User Devices Features",
    items: [
      "High-Performance Laptops & Desktops",
      "Mobile Devices & Tablets",
      "Ergonomic Accessories",
      "Seamless Integration with Business Applications",
      "Advanced Security Features",
      "24/7 Expert Support",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-laptop",
        text: "Enhanced productivity with high-performance devices.",
      },
      {
        icon: "fa fa-shield",
        text: "Advanced security features to protect sensitive data.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable solutions to meet growing business needs.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and regulations.",
      },
      {
        icon: "fa fa-headphones",
        text: "Expert support for seamless operations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Equip Your Workforce?",
    text: "Contact us today to learn more about our End User Devices Solutions and how we can help your business thrive.",
  },
};

export const EndUserDevicesPage = ({ data }) => {
  const endUserDevicesRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = endUserDevicesRef.current.querySelectorAll(".end-user-devices-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: endUserDevicesRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="end-user-devices-page" ref={endUserDevicesRef}>
      {/* Hero Section */}
      <div
        className="end-user-devices-hero-section"
        style={{ backgroundImage: `url(${endUserDevicesHero})` }}
      >
        <h1 className="end-user-devices-animate">{endUserDevicesData.hero.title}</h1>
        <p className="end-user-devices-animate">{endUserDevicesData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container end-user-devices-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="end-user-devices-animate">{endUserDevicesData.introduction.heading}</h2>
            {endUserDevicesData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="end-user-devices-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 end-user-devices-image-container">
            <img
              src={endUserDevicesImage}
              className="img-fluid end-user-devices-animate"
              alt="End User Devices"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container end-user-devices-features">
        <div className="row">
          <div className="col-md-6 end-user-devices-image-container">
            <img
              src={endUserDevicesHero}
              className="img-fluid end-user-devices-animate"
              alt="End User Devices Features"
              style={{ maxWidth: "100%" }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="end-user-devices-animate">{endUserDevicesData.features.heading}</h2>
            <ul>
              {endUserDevicesData.features.items.map((item, index) => (
                <li key={index} className="end-user-devices-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid end-user-devices-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="end-user-devices-animate">{endUserDevicesData.benefits.heading}</h2>
          <div className="benefits-cards">
            {endUserDevicesData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card end-user-devices-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container end-user-devices-cta">
        <h2 className="end-user-devices-animate">{endUserDevicesData.cta.heading}</h2>
        <p className="end-user-devices-animate">{endUserDevicesData.cta.text}</p>
        <button
          className="btn btn-primary end-user-devices-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};